import PlurallClient from '@plurall/client'
import { getToken } from './token'

const plurallClient = () =>
  new PlurallClient({
    apiURL: process.env.REACT_APP_PLURALL_API_URL,
    graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
    applicationId: process.env.REACT_APP_ID_APPLICATION,
    accessToken: getToken(),
  })

export default plurallClient
